import workspaceQuery from '../../../graphql/queries/web/WebPageWorkspaceQuery.graphql';
import listQuery from '../../../graphql/queries/web/WebPageListQuery.graphql';
import instanceQuery from '../../../graphql/queries/web/WebPageQuery.graphql';
import defaultQuery from '../../../graphql/queries/web/WebPageDefault.graphql';
import mutationQuery from '../../../graphql/mutations/web/WebPageMutation.graphql';
import fragment from '../../../graphql/fragments/web/WebPageFragment.graphql';
import { EntityType } from '../../../@types/entityTypes';

const WebPage: EntityType = {
  type: 'WebPage',
  title: 'Web Pages',
  formTitle: 'Web Page',
  formUrl: '/Web/Page/Details/',
  workspaceUrl: '/Web/Page/Workspace/',
  instance: instanceQuery,
  workspace: workspaceQuery,
  default: defaultQuery,
  update: mutationQuery,
  list: listQuery,
  dropdown: {
    query: listQuery,
    valueKey: 'id',
    labelKey: 'title',
  },
  fragment,
  screenReference: 'WEB_PAGES',
};

export default WebPage;
